// import './Popup Styles/Additional.css'

// function Additional(props) {
//   return (
//     <>
    
//       <div className="mainbox" > 
//       <div style={{display: "flex", alignItems: "center"}}> 
//         <input className='checkbox' type="checkbox" id={props.id} value={props.checked} onChange={(e) => props.onChange(e.target.checked)} style={ {marginTop:"-3.5%"}}></input>
//         <p id='addname'>{props.name}</p>
//         </div>
//         <img className="topimage" src={props.img} alt=""/>   
//         <p id='addprice'>Rs.{props.price}</p>  
//         </div>
      
//       <hr className='divider'></hr>
      
//     </>
//   );
// }

// export default Additional;
import './Popup Styles/Additional.css';
import React, { useState } from 'react';

function Additional(props) {
  const [isChecked, setIsChecked] = useState(props.checked || false);

  const handleDivClick = () => {
    const updatedChecked = !isChecked;
    setIsChecked(updatedChecked);
    props.onChange(updatedChecked);
  };

  const handleCheckboxChange = (e) => {
    const updatedChecked = e.target.checked;
    setIsChecked(updatedChecked);
    props.onChange(updatedChecked);
  };

  return (
    <>
      <div className="mainbox" onClick={handleDivClick}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <input
            className="checkbox"
            type="checkbox"
            id={props.id}
            checked={isChecked}
            onChange={handleCheckboxChange}
            style={{ marginTop: '-3.5%' }}
          />
          <p id="addname">{props.name}</p>
        </div>
        <img className="topimage" src={props.img} alt="" />
        <p id="addprice">Rs.{props.price}</p>
      </div>

      <hr className="divider" />
    </>
  );
}

export default Additional;

